import React, { useState, useEffect } from 'react'
import { findIndex } from 'lodash'
import AttorneyType from './AttorneyType'
import AttorneyPerson from './AttorneyPerson'

export default function Attorney({
  schema: _schema,
  showCommandButton,
  projectVersionId,
  updateIsInvalidAttorneyPerson = () => {},
}) {
  const [isEditPerson, setIsEditPerson] = useState({})
  const [schame, setSchema] = useState(_schema)

  useEffect(() => {
    if (!schame.attorneyPerson) {
      return
    }
    const inValidPerson = schame.attorneyPerson.filter((person) => person.isInitial)
    inValidPerson.forEach((person) => {
      handleSetIsEditPerson(person.id, true)
    })
    if (inValidPerson.length > 0) {
      updateIsInvalidAttorneyPerson(true)
    } else {
      updateIsInvalidAttorneyPerson(false)
    }
  }, [schame.attorneyPerson])

  const handleUpdateAllPerson = (updatedPerson) => {
    setSchema((state) => {
      return {
        ...state,
        attorneyPerson: updatedPerson,
      }
    })
  }

  const updatePerson = (person) => {
    setSchema((state) => {
      let updatedPersons = [...state.attorneyPerson]
      const existAttorneyPersonIndex = findIndex(state.attorneyPerson, { id: person.id })
      if (existAttorneyPersonIndex > -1) {
        updatedPersons[existAttorneyPersonIndex] = person
      }

      return {
        ...state,
        attorneyPerson: updatedPersons,
      }
    })
  }

  const handleSetIsEditPerson = (id, isEdit) => {
    setIsEditPerson((state) => {
      let updatedIsEdit = { ...state }
      updatedIsEdit[id] = isEdit
      return updatedIsEdit
    })
  }

  return (
    <>
      <AttorneyType
        schema={schame?.attorneyType}
        showCommandButton={showCommandButton}
        updatePerson={handleUpdateAllPerson}
      />
      {schame?.attorneyPerson &&
        schame?.attorneyPerson.map((person) => {
          return (
            <AttorneyPerson
              key={person.id}
              header={`ผู้ได้รับ${person.title}`}
              schema={person}
              isEdit={isEditPerson[person.id]}
              setIsEdit={(isEdit) => handleSetIsEditPerson(person.id, isEdit)}
              showCommandButton={showCommandButton}
              updatePerson={updatePerson}
              projectVersionId={projectVersionId}
            />
          )
        })}
    </>
  )
}
